import { useStore } from '@/store'
import './recallList.scss'
import { useLocal } from '@/i18n/LocalContext'
import { useCallback, useEffect, useState } from 'react'
import KowTitle from '../KowTitle/KowTitle'
import CodeInput from '../CodeInput/CodeInput'
import { copy } from '@activity/utils'
import { toast } from '@/utils'
import { checkPlayer, createServerName2 } from '@/request/utils'
import { clickReport } from '@/report'

export default function RecallList() {
  const { $t } = useLocal()
  const { state } = useStore()
  const friends = state.friends
  const code = state.login.userInfo.playerId
  const isBinded = state.login.userInfo.isBinded
  const [list, setlist] = useState<
    Array<{
      playerName: string
      playerId: string
      integral: string
    }>
  >([])

  useEffect(() => {
    if (!friends.length) return

    const newList = friends.map(
      (obj) =>
        ({
          playerName: `<span class="text-nowrap">${createServerName2(
            obj.kid
          )}-${obj.name}</span>`,
          playerId: obj.pid,
          integral: obj.point.toLocaleString(),
        } as typeof list[number])
    )
    setlist(newList)
  }, [friends])

  const _copy = useCallback(async () => {
    clickReport('copy')
    if (!(await checkPlayer('copy'))) return

    if (!code) return

    copy(code)
    toast($t('复制成功！'))
  }, [code])

  return (
    <div className="recall-list-box">
      <KowTitle text={$t('回归领主')} />
      <div className="recall-list-container">
        {!isBinded ? (
          <div className="recall-text-box">
            <p className="recall-text">{$t('登录后查看')}</p>
          </div>
        ) : list.length ? (
          <div className="recall-list">
            <div className="record-table">
              <ul className="record-table-header">
                <li className="record-table-header-item">
                  {$t('邀请领主名称')}
                </li>
                <li className="record-table-header-item">
                  {$t('邀请领主UID')}
                </li>
                <li className="record-table-header-item">{$t('已获得积分')}</li>
              </ul>
              <div className="record-table-body">
                <div className="record-table-body__inner">
                  {list.map((item) => (
                    <ul key={item.playerId} className="record-table-row">
                      <li className="record-table-cell">
                        <div
                          className="record-table-item"
                          dangerouslySetInnerHTML={{ __html: item.playerName }}
                        ></div>
                      </li>
                      <li className="record-table-cell">
                        <div className="record-table-item">
                          <span>{item.playerId}</span>
                        </div>
                      </li>
                      <li className="record-table-cell">
                        <div className="record-table-item">
                          <span>{item.integral}</span>
                        </div>
                      </li>
                    </ul>
                  ))}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="recall-text-box">
            <p className="recall-text">
              {$t('未查询到邀请领主信息，快去邀请其他领主参与活动吧！')}
            </p>
            <p className="recall-text">{$t('（活动期间至多邀请3名）')}</p>
          </div>
        )}
        <div className="code-box">
          <span className="code-box__name">{$t('邀请码')}</span>
          <CodeInput readOnly={true} value={code} />
        </div>
        <div className="recall-btn-box">
          <a className="recall-btn btn-active" onClick={_copy}>
            <span className="recall-btn__text">{$t('复制')}</span>
          </a>
        </div>
      </div>
    </div>
  )
}
